/**
 * Created by ivan on 21.07.2026
 */

const HourglassComponent = function (unit) {
    UnitComponent.call(this, unit);
};

HourglassComponent.prototype = Object.create(UnitComponent.prototype);
HourglassComponent.prototype.constructor = HourglassComponent;

HourglassComponent.prototype.needActivateConfirmation = function () {
    const selection = Merge2.current.field.lastSelection;
    return !(selection && this.unit.x === selection.x && this.unit.y === selection.y);
};

HourglassComponent.prototype.handleClick = function () {
    if (this.tryActivate()) {
        cleverapps.effects.fire("ui.button.click");
        return true;
    }
};

HourglassComponent.prototype.tryActivate = function () {
    if (this.activated || this.needActivateConfirmation()) {
        return false;
    }

    const generators = this.listAffectedGenerators();

    if (generators.length === 0) {
        this.unit.squeeze();
        cleverapps.effects.fire("merge2.generator.off");
        return false;
    }

    this.activate(generators);
    return true;
};

HourglassComponent.prototype.activate = function (generators) {
    this.activated = true;

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTER_USE}-${this.unit.code}`, { itemId: "generator", value: generators.length });
    cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BOOSTER_USE_DAU}-${this.unit.code}`);

    const duration = cleverapps.parseInterval(`${this.unit.getData().hourglass.duration} minutes`);

    generators.forEach((generator) => {
        generator.reduceCooldown(duration);
    });

    this.unit.onDestruction();
    this.unit.remove(true);
};

HourglassComponent.prototype.listAffectedGenerators = function () {
    const targets = this.unit.getData().hourglass.targets || [];

    return Merge2.current.field.listAvailableUnits((unit) => targets.includes(unit.code))
        .map((unit) => unit.findComponent(Merge2Generator))
        .filter((generator) => generator && generator.isRestoring());
};
